import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { NewCustomerCrmFields as CrmFields } from "@/hooks/use-new-customer-crm-fields";

/** Nettside og kundeeier i «Ny kunde». Tilstanden bor i `useNewCustomerCrmFields`. */
export function NewCustomerCrmFields({ fields }: { fields: CrmFields }) {
  return (
    <>
      {fields.websiteEnabled && (
        <div>
          <Label htmlFor="customer-website">Nettside (valgfritt)</Label>
          <Input
            id="customer-website"
            value={fields.website}
            onChange={(e) => fields.setWebsite(e.target.value)}
            placeholder="firma.no"
            autoComplete="off"
            aria-invalid={fields.websiteInvalid}
          />
          <p className={`text-xs mt-1 ${fields.websiteInvalid ? "text-destructive" : "text-muted-foreground"}`}>
            {fields.websiteInvalid
              ? "Skriv en adresse som firma.no eller https://firma.no."
              : "Vises på kundekortet og brukes til overvåkning."}
          </p>
        </div>
      )}
      {fields.ownersEnabled && (
        <div className="flex items-center gap-2">
          <Checkbox
            id="set-me-as-owner"
            checked={fields.setMeAsOwner}
            onCheckedChange={(checked) => fields.setSetMeAsOwner(checked === true)}
          />
          <Label htmlFor="set-me-as-owner">Sett meg som kundeeier</Label>
        </div>
      )}
    </>
  );
}
